// src/components/brandCustomization/shared/SaveResetButtons.jsx
import React from 'react';
import { FaSave, FaUndo, FaEye, FaSpinner } from 'react-icons/fa';

/**
 * SaveResetButtons - Grupo de botones de acción para formularios
 */
const SaveResetButtons = ({
    onSave,
    onReset,
    onPreview = null,
    isSaving = false,
    hasChanges = false,
    saveText = 'Guardar',
    resetText = 'Resetear',
    previewText = 'Vista Previa'
}) => {
    return (
        <div className="flex flex-col sm:flex-row gap-3 pt-6">
            {/* Botón Guardar */}
            <button
                onClick={onSave}
                disabled={isSaving || !hasChanges}
                className={`flex-1 flex items-center justify-center px-4 py-3 border border-transparent text-sm font-medium rounded-lg text-white transition-all ${isSaving || !hasChanges
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 shadow-lg hover:shadow-xl'
                    }`}
            >
                {isSaving ? (
                    <>
                        <FaSpinner className="mr-2 animate-spin" />
                        Guardando...
                    </>
                ) : (
                    <>
                        <FaSave className="mr-2" />
                        {hasChanges ? saveText : 'Sin Cambios'}
                    </>
                )}
            </button>

            {/* Botón Preview */}
            {onPreview && (
                <button
                    onClick={onPreview}
                    className="flex-1 sm:flex-none flex items-center justify-center px-4 py-3 border border-blue-600 text-sm font-medium rounded-lg text-blue-600 hover:bg-blue-50 transition-all"
                >
                    <FaEye className="mr-2" />
                    {previewText}
                </button>
            )}

            {/* Botón Reset */}
            <button
                onClick={onReset}
                className="flex-1 sm:flex-none flex items-center justify-center px-4 py-3 border border-gray-300 text-sm font-medium rounded-lg text-gray-700 hover:bg-gray-50 transition-all"
            >
                <FaUndo className="mr-2" />
                {resetText}
            </button>
        </div>
    );
};

export default SaveResetButtons;

